import type { MenuItem } from "../menu.type";
import type { NavigationModelLinkKey } from "@/modules/navigation";

import { Link } from "react-router";

import { useNavigationModelLink } from "@/modules/navigation";

export const useMenuItemModelLink = (key: NavigationModelLinkKey): MenuItem => {
  const link = useNavigationModelLink(key);

  if (!link) return null;

  const { text, icon, url } = link;

  return {
    key: url, // use `url` as key to handle 'active' state
    label: <Link to={url}>{text}</Link>,
    icon,
  };
};
